import { render } from "./deals-dashboard.vue?vue&type=template&id=6e823904"
import script from "./deals-dashboard.vue?vue&type=script&lang=js"
export * from "./deals-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__